import styled, {css} from 'styled-components'
import {CSSProperties} from 'react'

export const StyledContent = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 6}px;
    `
)

export const StyledTextWrapper = styled.div<{$width?: CSSProperties['width']}>(
    ({theme: {spacing, typography}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: ${spacing * 2}px;
        max-width: 535px;
        width: 100%;

        & h1 {
            ${typography.displaySm};
            font-weight: 500;
        }

        & p {
            ${typography.textMd};

            & strong {
                font-weight: 500;
            }
        }
    `
)

export const StyledWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 8}px;

        & strong {
            font-weight: 500;
        }

        & a {
            font-weight: 500;
            text-decoration-line: underline;
            cursor: pointer;
        }
    `
)
